import { render, staticRenderFns } from "./ProductsResultsTable.vue?vue&type=template&id=248564bb&scoped=true"
import script from "./ProductsResultsTable.vue?vue&type=script&lang=js"
export * from "./ProductsResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsResultsTable.vue?vue&type=style&index=0&id=248564bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248564bb",
  null
  
)

export default component.exports